import { HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import styled from 'styled-components';

const HolderWrapper = styled.div`
  font-size: 16px;
  width: 18px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colorBorder};
  cursor: grab;
  &:hover {
    color: ${props => props.theme.colorText};
  }
`;

export interface ISortableAttributeRowProps {
  attribute: string;
  prefix: string;
}

/** Singola riga sortable: handle drag + campo alias. */
export function SortableAttributeRow(props: ISortableAttributeRowProps) {
  const { attribute, prefix } = props;
  const {
    attributes: activatorAttributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: attribute,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
    >
      <FlexRow
        align="center"
        left={
          <HolderWrapper {...activatorAttributes} {...listeners}>
            <HolderOutlined aria-hidden />
          </HolderWrapper>
        }
      >
        <FormItem
          label={`Etichetta del campo ${attribute}`}
          name={`${prefix}aliases.${attribute}`}
        >
          <TextInput
            name={`${prefix}aliases.${attribute}`}
            placeholder={`Facoltativo: se vuoto verrà usato "${attribute}"`}
          />
        </FormItem>
      </FlexRow>
    </div>
  );
}
